module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetLow@2x.c3e4202.jpg";